export const WRAPPER_CSS_ID = 'bb-breadcrumbs';
export const BREADCRUMBS_CSS_CONTAINER = 'bb-breadcrumbs-container';
export const BREADCRUMBS_LEVELONE_CLASS_NAME = 'bb-breadcrumbs__levelOne';
export const BREADCRUMBS_LEVELTWO_CLASS_NAME = 'bb-breadcrumbs__levelTwo';
export const BREADCRUMBS_LAST_VISIBLE_CLASS_NAME = 'bb-breadcrumbs__lastVisible';
export const BREADCRUMBS_INVISIBLE_CLASS_NAME = 'bb-breadcrumbs__invisible';
export const BREADCRUMBS_RETURNLINK_CLASS_NAME = 'bb-breadcrumbs__homeLink';
export const BREADCRUMBS_LEVELTWO_TEXT = `${BREADCRUMBS_LEVELTWO_CLASS_NAME}__text`;
export const BREADCRUMBS_BACK_BUTTON_CLASS_NAME = 'bb-breadcrumbs__back-button';
export const BREADCRUMBS_URL_SPECTATE_PRODUCT_MAPPING = {
    '888-special': 'special',
    bets: 'bet-history',
    coms: 'competitions',
    e: 'event-page',
    fortoday: 'for-today',
    ipe: 'event-page',
    ips: '',
    madeforyou: 'made-for-you',
    o: 'outrights',
    olderBets: 'older-bets',
    openBets: '',
    settledBets: 'settled-bets',
    t: 'competitions-page',
    to: 'outrights',
};
